import { MessageOption } from "@/types/conversationTypes";

interface Props {
  option: MessageOption;
  isDisabled?: boolean;
  onOptionSelect?: (id: string, title: string) => void;
}

const RegularOption = ({ option, isDisabled, onOptionSelect }: Props) => {
  return (
    <div
      key={option.id}
      className="flex items-center space-x-3 p-3 border border-gray-200 rounded-lg hover:bg-gray-50 cursor-pointer transition-colors"
      onClick={() => !isDisabled && onOptionSelect?.(option.id, option.title)}
      role="button"
      aria-label={`Select option ${option.title}`}
    >
      {option.image && (
        <div className="flex-shrink-0">
          <img
            src={option.image}
            alt={option.title}
            className="w-12 h-12 object-cover rounded-lg"
          />
        </div>
      )}
      <div className="flex-1 min-w-0">
        <h4 className="text-sm font-medium text-gray-900 truncate">
          {option.title}
        </h4>
        <p className="text-xs text-gray-600 mt-0.5">{option.description}</p>
      </div>
      {!isDisabled && (
        <div className="flex-shrink-0">
          <span className="text-xs text-brand-accent font-medium hover:text-brand-accent/80">
            Select
          </span>
        </div>
      )}  
    </div>
  );
};

export default RegularOption;
